import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container } from 'react-bootstrap';
import InvoicesSearch from './search/InvoicesSearch';
import InvoicesTable from './table/InvoicesTable';
import PageBreadcrumb from '../common/components/layout/PageBreadcrumb';
import { useQueryString, setQueryString } from '../common/helpers/queryString';
import { searchInvoices } from './InvoicesActions';
import RouterPaths from '../constants/RouterPaths';
import { PrepareUrl } from '../common/helpers/PrepareUrl';
import { getDealer } from '../dealers/DealersActions';

let breadcrumbs = [];

function InvoicesPage() {
  const { dealerId } = useParams();
  const query = useQueryString();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const items = useSelector((state) => state.invoices.get('items'));
  const totalItems = useSelector((state) => state.invoices.get('totalItems'));
  const dealerDetails = useSelector((state) => state.dealers.get('dealerDetails'));

  const [dealerName, setDealerName] = useState(null);
  const [searchParams, setSearchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
    organizationId: null,
  });

  useEffect(() => {
    if (dealerId) {
      dispatch(getDealer(dealerId));
    } else {
      setDealerName(null);
    }
  }, [dispatch, dealerId]);

  useEffect(() => {
    if (dealerId && dealerDetails?.organization) {
      setDealerName(dealerDetails.organization.officialCompanyName || '');
      setSearchParams((prevState) => ({
        ...prevState,
        organizationId: dealerDetails.organization.id || null,
      }));
    }
  }, [dealerDetails, dealerId]);

  useEffect(() => {
    if (!dealerId) {
      setSearchParams((prevState) => ({
        ...prevState,
        organizationId: null,
      }));
    }
  }, [dealerId]);

  useEffect(() => {
    dispatch(searchInvoices(searchParams));
  }, [dispatch, searchParams]);

  const handleSearch = (values, { setSubmitting }) => {
    setSearchParams((prevState) => ({ ...prevState, ...values, offset: 0 }));
    setSubmitting(false);
  };

  const changeOffset = (value) => {
    setSearchParams((prevState) => ({
      ...prevState,
      offset: value,
    }));
    navigate(setQueryString(location, 'page', value + 1));
  };

  if (dealerId) {
    breadcrumbs = [
      { id: 1, type: 'home' },
      { id: 2, type: 'link', text: 'Dealers', url: RouterPaths.DEALERS },
      {
        id: 3,
        type: 'link',
        text: 'Edit Dealer',
        url: PrepareUrl(RouterPaths.DEALER_INFORMATION, { id: dealerId }),
      },
      { id: 4, type: 'span', text: 'Invoices' },
    ];
  } else {
    breadcrumbs = [
      { id: 1, type: 'home' },
      { id: 2, type: 'span', text: 'Invoices' },
    ];
  }

  const dealerOrganizationId = dealerDetails?.organization?.id || null;

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Invoices" />
      <InvoicesSearch
        onSearch={handleSearch}
        dealerName={dealerName}
        dealerOrganizationId={dealerOrganizationId}
      />
      <Col className="d-flex justify-content-end mb-3" />
      <InvoicesTable
        data={{ items, total: totalItems }}
        offset={searchParams.offset}
        changeOffset={changeOffset}
      />
    </Container>
  );
}

export default InvoicesPage;
